export default __webpack_public_path__ + "static/home1-322c33fccf4b6e0df54ce41a4f9a2986.png";